import {
  PlayerRoundEvents,
  PlayerRoundState,
  RoundState,
} from '@alienheadwars/football-card-manager-model';
import { localise } from '../../../../../locale/locale';
import { InLine } from '../../../../cards/playerCards/CardDimensions';
import { ExpandablePlayerCard } from '../../../../cards/playerCards/ExpandablePlayerCard';
import { CommentaryCard } from './CommentaryCard';
import { CommentaryTypography } from './CommentaryTypography';
import { neutralColours } from '../../../../cards/CardColours';

export interface PlayerEventCommentariesProps {
  roundState: RoundState;
}

export const PlayerEventCommentaries = (
  props: PlayerEventCommentariesProps
) => {
  return [
    ...props.roundState.attackingHand.flatMap((player) =>
      player.roundEvents.map((event) => (
        <PlayerEvent player={player} event={event} />
      ))
    ),
    ...props.roundState.defendingHand.flatMap((player) =>
      player.roundEvents.map((event) => (
        <PlayerEvent player={player} event={event} />
      ))
    ),
  ];
};

export interface PlayerEventProps {
  player: PlayerRoundState;
  event: PlayerRoundEvents;
}
export const PlayerEvent = (props: PlayerEventProps) => {
  const { player, event } = props;
  return (
    <CommentaryCard colours={neutralColours}>
      <ExpandablePlayerCard player={player.playerDetails} dimensions={InLine} />
      <CommentaryTypography>
        {localise(`commentary.playerRoundEvent.${event}`)}
      </CommentaryTypography>
    </CommentaryCard>
  );
};
